/**
 * React context to expose the plugin registry throughout the component tree.
 */

import React, { createContext, useContext } from 'react';
import { IPluginRegistry } from './types';
import { pluginRegistry } from './registry';

const PluginRegistryContext = createContext<IPluginRegistry>(pluginRegistry);

export interface PluginRegistryProviderProps {
  registry?: IPluginRegistry;
  children: React.ReactNode;
}

export function PluginRegistryProvider({
  registry = pluginRegistry,
  children,
}: PluginRegistryProviderProps) {
  return (
    <PluginRegistryContext.Provider value={registry}>
      {children}
    </PluginRegistryContext.Provider>
  );
}

export function usePluginRegistry(): IPluginRegistry {
  return useContext(PluginRegistryContext);
}
